<template>
  <main class="safe-page article-todo">
    <AppNavBar :title="title" :fixed="false" :placeholder="false" />
    <section class="article-todo__body">
      <van-empty image="search" :description="description" />
    </section>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const title = computed(() => t(route.meta.titleKey || 'article.detail'));
const description = computed(() => t(route.meta.descriptionKey || 'article.openDetailTodo'));
</script>

<style scoped lang="scss">
.article-todo {
  background: var(--wp-color-page);
}

.article-todo__body {
  padding-top: 40px;
}
</style>
